module.exports = __webpack_public_path__ + "img/icon-smartphone.69c1766a.svg";